import { useIntl } from "react-intl";
import { Message } from "semantic-ui-react";

export const Unauthorized = () => {
    const intl = useIntl();
    return <Message header={intl.formatMessage({ id: "permissionToViewContent" })} icon="ban" />;
};
